// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2qLou","legacyBtn":"MutateMid_legacyBtn__2svFZ"};